"use client";

import { useEffect, useState } from "react";
import type { SearchQuery } from "@/types/searchquery";

interface DynamicSearchQueryBuilderProps {
  sendDataToParent: (query: SearchQuery) => void;
  queryCountryName?: string;
  queryResortId?: number | null;
}

const DynamicSearchQueryBuilder = ({
  sendDataToParent,
  queryCountryName,
  queryResortId,
}: DynamicSearchQueryBuilderProps) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (isInitialized) return;

    const formatDate = (date: Date) => date.toISOString().split("T")[0];

    const initialQuery: Partial<SearchQuery> = {
      CountryId: null,
      ResortId: null,
      ResortIds: [],
      ChaletId: null,
      DateFrom: formatDate(
        new Date(Date.now() + 30 * 24 * 60 * 60 * 1000) // 30 days from now
      ),
      DateTo: formatDate(
        new Date(Date.now() + 37 * 24 * 60 * 60 * 1000) // 37 days from now
      ),
      Adults: 2,
      Children: null,
      Infants: null,
      TransferId: null,
      FoodId: null,
      HireId: null,
      LiftPassId: null,
      AirportFromId: null,
      AirportToId: null,
      Rooms: 1,
      Currency: null,
      AttributeRefinerIds: [],
      PageSize: 25,
      PageCount: 0,
      SortDirection: null,
      queryStringNull: true,
      TotalCost: null,
      CountrySearchArray: [],
      CustomSearchArray: [],
      SearchType: "SingleResort",
    };

    // Use Resort ID if available, otherwise fallback to Country Name
    if (queryResortId) {
      initialQuery.ResortIds = [queryResortId];
    } else if (queryCountryName) {
      switch (queryCountryName) {
        case "Austria":
          initialQuery.CountrySearchArray = [1];
          initialQuery.CountryId = 1;
          break;
        case "France":
          initialQuery.CountrySearchArray = [2];
          initialQuery.CountryId = 2;
          break;
        case "Italy":
          initialQuery.CountrySearchArray = [3];
          initialQuery.CountryId = 3;
          break;
        case "Switzerland":
          initialQuery.CountrySearchArray = [4];
          initialQuery.CountryId = 4;
          break;
        default:
          break;
      }
    }

    setIsInitialized(true);
    sendDataToParent(initialQuery as SearchQuery);
  }, [isInitialized, queryCountryName, queryResortId, sendDataToParent]);

  return null;
};

export default DynamicSearchQueryBuilder;
